export default "__VITE_ASSET__BdSQDLA$__"